import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ErrorDialogNotifierService {
    private onShowErrorDialogSource: Subject<string>;
    public onShowErrorDialog: Observable<string>;

    constructor() {
        this.onShowErrorDialogSource = new Subject<string>();
        this.onShowErrorDialog = this.onShowErrorDialogSource.asObservable();
    }

    public publishMessage(message: string) {
        this.onShowErrorDialogSource.next(message);
    }
}